import { execFileSync } from 'node:child_process';
import { homedir } from 'node:os';
import { join } from 'node:path';

/** Common install locations not always present in a long-lived bridge process PATH. */
export function getBridgeAgentPathEntries(home = process.env.HOME ?? homedir()): string[] {
  const entries = [
    join(home, '.local', 'bin'),
    join(home, '.npm-global', 'bin'),
    '/usr/local/bin',
  ];
  const prefix = process.env.NPM_CONFIG_PREFIX;
  if (prefix) entries.push(join(prefix, 'bin'));
  try {
    const npmBin = execFileSync('npm', ['bin', '-g'], { encoding: 'utf8', timeout: 2_000 }).trim();
    if (npmBin) entries.push(npmBin);
  } catch {
    /* npm unavailable or slow */
  }
  return entries;
}

export function augmentPath(pathValue: string | undefined, extra: string[]): string {
  const current = pathValue ?? '';
  const parts = current.split(':').filter(Boolean);
  const seen = new Set(parts);
  const prefix: string[] = [];
  for (const entry of extra) {
    if (!entry || seen.has(entry)) continue;
    seen.add(entry);
    prefix.push(entry);
  }
  if (prefix.length === 0) return current;
  return current ? `${prefix.join(':')}:${current}` : prefix.join(':');
}

/** Prepend known agent install dirs so `which` and spawn find freshly installed CLIs. */
export function ensureBridgeAgentPathInProcessEnv(): void {
  const extra = getBridgeAgentPathEntries();
  process.env.PATH = augmentPath(process.env.PATH, extra);
}

export function bridgeAgentPathEnv(base: NodeJS.ProcessEnv = process.env): NodeJS.ProcessEnv {
  return { ...base, PATH: augmentPath(base.PATH, getBridgeAgentPathEntries()) };
}
